/*
 * Средства для работы с полями формы
 * Утилиты валидации, форматирования и масок.
 * Без зависимостей от Alpine.js и UI.
 *
 * Основной функционал: возвращает объект FIELD_SCHEMAS с правилами для типовых полей
 * */

window.FFK = (() => {
	"use strict";
	// ═══════════════════════════════════════════════════════════════════════════
	// ФОРМАТТЕРЫ
	// ═══════════════════════════════════════════════════════════════════════════
	const Formatter = {
		// базовое для всего
		baseFormat: (value) => {
			if (value === "" || value === undefined || value === null) {
				return '';
			}
			;
			value = String(value);
			value = value.trimStart();

			return value;
		},
		// базовое для строк
		baseWordFormat: (value) => {
			value = Formatter.baseFormat(value);
			if (!value)
				return '';

			// Удаляем латинские буквы
			//value = value.replace(/[a-zA-Z]/g, '');

			// убираем дублирование
			value = value.replace(/\){2,}/g, ')');  // убираем двойную левую скобку
			value = value.replace(/\({2,}/g, '(');  // убираем двойную правую скобку
			value = value.replace(/\'{2,}/g, '\'');  // убираем двойной апостро
			value = value.replace(/\.{2,}/g, '.');  // убираем двойную точку
			value = value.replace(/\s{2,}/g, ' ');  // убирает двойной пробел
			value = value.replace(/\-{2,}/g, '-');  // убирает двойной дефис

			// убираем лишние пробелы
			value = value.trimStart(); // убирает пробел в самом начале
			value = value.replace(/\-\s+/g, '-');  // убирает пробел после дефиса2

			return value;
		},

		digitsOnly: (value) => {
			value = Formatter.baseFormat(value) || "";
			if (!value)
				return '';

			return value.replace(/\D/g, '');
		},
		fio: (value) => {
			// https://www.consultant.ru/document/cons_doc_LAW_410788/763145d8bce1267a0501117c28ebd122104c1b8e/

			value = Formatter.baseWordFormat(value);
			if (!value)
				return '';

			// разрешенные символы
			value = value.replace(/[^а-яА-ЯёЁ\-\s\.ivIV\'\,\(\)]/g, '');

			// Cлово состоит только из римских цифр (поддерживаем базовый набор)
			const isRomanNumeral = (word) => /^[IV]+$/i.test(word);

			// каждое слово с заглавной буквы
			const words = value.split(' ');
			const formatted = words
				.map((word, idx) => {
					// Пропускаем слова, начинающиеся с дефиса
					if (word[0] === '-')
						return '';

					// Если это римская цифра — оставляем заглавной
					if (isRomanNumeral(word)) {
						return word.toUpperCase();
					}

					return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
				});
			//.filter(w => w); // убираем пустые

			return formatted.join(' ');
		},
		day: (day) => Math.min(31, Math.max(1, Number(day))),
		month: (month) => Math.min(12, Math.max(1, Number(month))),
		year: (year) => Math.min(2100, Math.max(1900, Number(year))),

		/*
		 * Заглавная первая буква у каждого слова
		 */
		address: (value) => {
			value = Formatter.baseWordFormat(value);
			if (!value)
				return '';

			// value.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
			return value;
		},

		orgName: (value) => {
			value = Formatter.baseWordFormat(value);
			if (!value)
				return '';

			// Разрешаем: кириллицу, латинские римские цифры (IVXLCDM), цифры, дефис, пробелы, точки, кавычки, скобки
			value = value.replace(/[^а-яА-ЯёЁ\s\-\.\'\"\(\)\»\«\№\+,NIVXLCDM0-9]/g, '');

			// Каждое слово с заглавной
			//value.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
			return value;
		},

		bik: (value) => {
			value = Formatter.baseWordFormat(value);
			value = Formatter.digitsOnly(value);
			if (!value)
				return '';

			return value;
		},

		vin: (value) => {
			value = Formatter.baseWordFormat(value);
			if (!value)
				return '';

			// Оставляем только разрешённые символы: a-h, j-n, p-r, z (регистронезависимо) и 0-9
			// Исключаем i, o, q (и их заглавные варианты), так как они визуально похожи на 1 и 0
			value = value.replace(/[^a-hj-npr-zA-HJ-NPR-Z0-9]/g, '');

			value = value.toUpperCase();

			return value;
		},

		date: (value) => {

			value = Formatter.baseFormat(value);
			if (!value) {
				return '';
			}


			// Убираем время, если есть (всё после пробела), чтобы не мешало парсингу
			const datePart = value.split(/[ T]/)[0];

			// === 1. Парсинг стандартных форматов ===

			// JS Date.toString() формат: "Fri May 08 2026 ..."
			if (/^[A-Z][a-z]{2}\s[A-Z][a-z]{2}\s\d{2}\s\d{4}/.test(value)) {
				const date = new Date(value);
				if (!isNaN(date.getTime())) {
					const d = String(date.getDate()).padStart(2, '0');
					const m = String(date.getMonth() + 1).padStart(2, '0');
					const y = date.getFullYear();
					return `${d}.${m}.${y}`;
				} else {
					console.error("Дату невозможно отформатировать!");
					return "";
				}
			}


			// ISO: YYYY-MM-DD
			if (/^\d{4}-\d{1,2}-\d{1,2}/.test(datePart)) {
				const [year, month, day] = datePart.split('-');

				const d = Formatter.day(day);
				const m = Formatter.month(month);
				const y = Formatter.year(year);
				return `${String(d).padStart(2, '0')}.${String(m).padStart(2, '0')}.${y}`;
			}

			// Европейский: DD.MM.YYYY или DD-MM-YYYY
			if (/^\d{1,2}[.-]\d{1,2}[.-]\d{4}/.test(datePart)) {
				const separator = datePart.includes('.') ? '.' : '-';
				const [day, month, year] = datePart.split(separator);

				const d = Formatter.day(day);
				const m = Formatter.month(month);
				const y = Formatter.year(year);
				return `${String(d).padStart(2, '0')}.${String(m).padStart(2, '0')}.${y}`;
			}

			// === 2. Пошаговый ввод цифрами ===

			// Чистые цифры (например, 17122020, 01012023) или нестандартный ввод
			// Предполагаем формат DDMMYYYY
			let digits = value.replace(/\D/g, '').slice(0, 8);
			let formatted = "";

			// День (1-2 цифры)
			if (digits.length >= 1) {
				const dayRaw = digits.slice(0, Math.min(2, digits.length));
				if (dayRaw.length === 2) {
					formatted += String(Formatter.day(dayRaw));
				} else {
					formatted += dayRaw; // частичный ввод — как есть
				}
			}
			// Точка после дня, если ввели хотя бы 2 цифры
			if (digits.length >= 2) {
				formatted += '.';
			}
			// Месяц (3-4 цифры)
			if (digits.length >= 3) {
				const monthRaw = digits.slice(2, Math.min(4, digits.length));
				if (monthRaw.length === 2) {
					formatted += String(Formatter.month(monthRaw));
				} else {
					formatted += monthRaw; // частичный ввод — как есть
				}
			}
			// Точка после месяца, если ввели хотя бы 4 цифры
			if (digits.length >= 4) {
				formatted += '.';
			}
			// Год (5-8 цифры)
			if (digits.length >= 5) {
				const yearRaw = digits.slice(4, 8);
				if (yearRaw.length === 4) {
					formatted += String(Formatter.year(yearRaw));
				} else {
					formatted += yearRaw; // частичный ввод — как есть
				}
			}
			return formatted;
		},
		minutes: (value) => {
			value = Formatter.baseFormat(value);
			value = Formatter.digitsOnly(value);
			if (!value)
				return "";

			const num = Number(value);
			if (isNaN(num)) {
				return "00";
			}

			if (num < 0 || num > 59) {
				return "00";
			}
			return value;
		},
		hours: (value) => {
			value = Formatter.baseFormat(value);
			value = Formatter.digitsOnly(value);
			if (!value)
				return "";

			const num = Number(value);
			if (isNaN(num)) {
				return "00";
			}

			if (num < 0 || num > 23) {
				return "00";
			}
			return value;
		},

		/**
		 * +7 (___) ___-__-__
		 */
		phone: (value) => {
			value = Formatter.baseFormat(value);
			if (!value)
				return '';

			// Очищаем от всего кроме цифр
			let digits = value.replace(/\D/g, '');

			// 8 на +7
			if (digits.startsWith('8')) {
				digits = '7' + digits.slice(1);
			}

			let formatted = '+7';
			if (digits.length > 1) {
				formatted += ' (' + digits.slice(1, 4);
			}
			if (digits.length > 4) {
				formatted += ') ' + digits.slice(4, 7);
			}
			if (digits.length > 7) {
				formatted += '-' + digits.slice(7, 9);
			}
			if (digits.length > 9) {
				formatted += '-' + digits.slice(9, 11);
			}

			return formatted;
		},

		/**
		 * Форматтер цены:
		 * - разделяет тысячи пробелами (1 500 000)
		 * - заменяет точку на запятую для копеек
		 * - всегда показывает 2 знака после запятой (добавляет 00 если нет)
		 */
		price: (value) => {
			// Пустые значения
			if (value === "" || value === undefined || value === null) {
				return '';
			}

			// Приводим к строке и убираем пробелы (если цена уже отформатирована)
			value = String(value).trim().replace(/\s/g, '');

			// Разделяем целую и дробную часть по запятой или точке
			const parts = value.split(/[,.]/);
			let integerPart = parts[0].replace(/\D/g, ''); // только цифры
			let decimalPart = parts[1] ? parts[1].slice(0, 2).replace(/\D/g, '') : "00";

			// Нормализация дробной части: всегда 2 знака
			if (decimalPart.length === 0) {
				decimalPart = "00";
			} else if (decimalPart.length === 1) {
				decimalPart += "0";
			}

			// Если целая часть пустая — ставим 0
			if (!integerPart) {
				integerPart = "0";
			}

			// Добавляем пробелы как разделитель тысяч (русский формат)
			const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

			// Возвращаем в формате: 1 500 000,00
			return `${formattedInteger},${decimalPart}`;
		},
	};

	// форматирование перед отправкой на сервер
	const BackendFormatter = {
		date: (value) => {
			let val = value;

			if (value.endsWith(".")) {
				val = value.slice(0, -1);
			}

			return val;
		},
		number: (value) => {
			let val = value;

			if (typeof value === 'number') {
				val = String(value);
			}

			val = val.replaceAll(",", ".").replaceAll(" ", "").trim();
			return val; // возвращаем именно строку, потому что пустая строка будет возвращать 0!

			//			const number = Number(val);
			//
			//			if(Number.isNaN(number)) {
			//				PARAMS.isStage && console.error("этот форматер только для цельных чисел а пришел nan", value);
			//				return val;
			//			} else {
			//				return number
			//			}
		},
	}

	// ═══════════════════════════════════════════════════════════════════════════
	// ВАЛИДАТОРЫ
	// ═══════════════════════════════════════════════════════════════════════════
	const Validator = {
		// Простая валидация непустого значения
		notEmpty(value) {
			let isValid = true;

			// 1. Проверка на null и undefined (важно сделать это первым,
			// так как typeof null возвращает 'object')
			if (value === null || value === undefined) {
				isValid = false;
			}
			// 2. Проверка массивов (используем нативный Array.isArray)
			else if (Array.isArray(value)) {
				isValid = value.length > 0;
			}
			// 3. Проверка объектов (проверяем только "чистые" объекты,
			// чтобы не сломать проверку для Date, Map, Set и т.д.)
			else if (typeof value === 'object' && value.constructor === Object) {
				isValid = Object.keys(value).length > 0;
			}
			// 4. Проверка строк
			else if (typeof value === 'string') {
				const trimmed = value.trim();
				isValid = trimmed !== '' && trimmed !== 'null' && trimmed !== 'undefined';
			}
			// 5. Для чисел (например, 0) и булевых значений (false)
			// isValid останется true, так как это не "пустота".

			return {
				isValid: isValid,
				error: isValid ? {} : { message: "Заполните поле", code: 1 },
			};
		},

		inn: (value, ctx) => {
			value = String(value);
			const error = {};
			let isValid = false;

			const isUr = ctx?.isUr ?? false;
			const isFiz = ctx?.isFiz ?? false;
			const isIp = ctx?.isIp ?? false;
			const isUnknownType = !isUr && !isFiz && !isIp;

			let requiredLen = [10, 12]; // если не указан тип то проверка и для фл и для юл
			if (isUr && !isFiz && !isIp) {
				requiredLen = [10];
			} else if ((isFiz || isIp) && !isUr) {
				requiredLen = [12];
			}


			if (!value.length) {
				error.code = 1;
				error.message = 'ИНН пуст';
			} else if (/[^0-9]/.test(value)) {
				error.code = 2;
				error.message = 'ИНН может состоять только из цифр';
			} else if (requiredLen.indexOf(value.length) === -1) {
				error.code = 3;
				error.message = `ИНН может состоять только из ${requiredLen.length > 1 ? '10 или 12' : requiredLen[0]} цифр`;
			} else if (value === '0000000000' || value === '000000000000') {
				error.code = 4;
				error.message = 'ИНН не может состоять из нулей';
			} else {
				var checkDigit = function (inn, coefficients) {
					var n = 0;
					for (var i in coefficients) {
						n += coefficients[i] * inn[i];
					}
					return parseInt(n % 11 % 10);
				};
				switch (value.length) {
					case 10:
						if (isUr || isUnknownType) {
							var n10 = checkDigit(value, [2, 4, 10, 3, 5, 9, 4, 6, 8]);
							if (n10 === parseInt(value[9])) {
								isValid = true;
							}
						}

						break;
					case 12:
						if (isFiz || isIp || isUnknownType) {
							var n11 = checkDigit(value, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
							var n12 = checkDigit(value, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
							if ((n11 === parseInt(value[10])) && (n12 === parseInt(value[11]))) {
								isValid = true;
							}
						}

						break;
				}
				if (!isValid) {
					error.code = 4;
					error.message = 'Некорректный ИНН';
				}
			}

			return {
				isValid: isValid,
				error: error,
			};
		},
		kpp: (value) => {
			value = String(value);
			const error = {};
			let isValid = false;

			if (!value.length) {
				error.code = 1;
				error.message = 'КПП пуст';
			} else if (value.length !== 9) {
				error.code = 2;
				error.message = 'КПП может состоять только из 9 знаков (цифр или заглавных букв латинского алфавита от A до Z)';
			} else if (!/^[0-9]{4}[0-9A-Z]{2}[0-9]{3}$/.test(value)) {
				error.code = 3;
				error.message = 'Неправильный формат КПП';
			} else {
				isValid = true;
			}

			return {
				isValid: isValid,
				error: error,
			};
		},

		year: (value) => {
			return {// для валидации
				isValid: YearUtils.isValid(value),
				error: YearUtils.isValid(value) ? {} : {
					message: `Год должен быть от ${YearUtils.MIN} до ${YearUtils.MAX}`,
					code: 1
				}
			}
		},
		efrsb_id: (value) => {
			value = String(value);
			const error = {};
			let isValid = false;

			if (!/^[0-9]{7,8}$/.test(value)) {
				error.message = 'Идентификационный номер торгов на ЕФРСБ должен состоять из 7 или 8 цифр!';
			} else {
				isValid = true;
			}

			return {
				isValid: isValid,
				error: error,
			};
		},
		ogrn: (value) => {
			value = String(value);
			const error = {};
			let isValid = false;

			if (!value.length) {
				error.code = 1;
				error.message = 'ОГРН пуст';
			} else if (/[^0-9]/.test(value)) {
				error.code = 2;
				error.message = 'ОГРН может состоять только из цифр';
			} else if (value.length !== 13) {
				error.code = 3;
				error.message = 'ОГРН может состоять только из 13 цифр';
			} else if (value === '0000000000' || value === '000000000000') {
				error.code = 4;
				error.message = 'ОГРН не может состоять из нулей';
			} else {
				var n13 = parseInt((parseInt(value.slice(0, -1)) % 11).toString().slice(-1));
				if (n13 === parseInt(value[12])) {
					isValid = true;
				} else {
					error.code = 4;
					error.message = 'Некорректный ОГРН';
				}
			}

			return {
				isValid: isValid,
				error: error,
			};
		},

		snils: (value) => {
			value = String(value);
			const error = {};
			let isValid = false;

			value = value.replace(/[\-\ ]/g, "");
			if (!value.length) {
				error.code = 1;
				error.message = 'СНИЛС пуст';
			} else if (/[^0-9]/.test(value)) {
				error.code = 2;
				error.message = 'СНИЛС может состоять только из цифр';
			} else if (value.length !== 11) {
				error.code = 3;
				error.message = 'СНИЛС может состоять только из 11 цифр';
			} else {
				if (value <= 100199800) {
					//Проверка контрольного числа Страхового номера проводится только для номеров больше номера 001-001-998
					isValid = true;
				}
				var sum = 0;
				for (var i = 0; i < 9; i++) {
					sum += parseInt(value[i]) * (9 - i);
				}
				var checkDigit = 0;
				if (sum < 100) {
					checkDigit = sum;
				} else if (sum > 101) {
					checkDigit = parseInt(sum % 101);
					if (checkDigit === 100) {
						checkDigit = 0;
					}
				}
				if (checkDigit === parseInt(value.slice(-2))) {
					isValid = true;
				} else {
					error.code = 4;
					error.message = 'Неправильный СНИЛС';
				}
			}

			return {
				isValid: isValid,
				error: error,
			};
		},
		rs: (rs, bik) => {
			rs = String(rs);
			bik = String(bik);
			const error = {};
			let isValid = false;

			rs = rs.replace(/[\-\ ]/g, "");
			bik = bik.replace(/[\ ]/g, "");
			if (!rs.length) {
				error.code = 1;
				error.message = 'Счет пуст';
			} else if (/[^0-9]/.test(rs)) {
				error.code = 2;
				error.message = 'Счет может состоять только из цифр';
			} else if (rs.length !== 20) {
				error.code = 3;
				error.message = 'Счет может состоять только из 20 цифр';
			} else {
				if (rs.substr(0, 2) === "03") {
					//казначейский??
					isValid = true;

					return {
						isValid: true,
						error: error,
					};
				}

				var bikRs;
				if (bik.substring(6, 8) === "00") {
					bikRs = "0" + bik.substring(4, 6) + rs;
				} else {
					bikRs = bik.toString().slice(-3) + rs;
				}
				var checksum = 0;
				var coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1];
				for (var i in coefficients) {
					checksum += coefficients[i] * (bikRs[i] % 10);
				}
				if (checksum % 10 === 0) {
					isValid = true;
				} else {
					error.code = 4;
					error.message = 'Неверно указан расчетный счет или БИК';
				}
			}

			return {
				isValid: isValid,
				error: error,
			};
		},
		rsOwner: (rs, name) => {
			const error = {};
			const d = Formatter.digitsOnly(rs);
			const n = String(name ?? "").trim().toLowerCase();
			const hasIpPrefix = n.startsWith("ип ") || n.startsWith("индивидуальный");
			if (d.startsWith("40802") && !hasIpPrefix) {
				error.message = "В наименовании получателя должно быть указано ИП, так как счет принадлежит ИП.";
				return { isValid: false, error };
			}
			if (!d.startsWith("40802") && hasIpPrefix) {
				if (d.length < 5) {
					return { isValid: true, error };
				}
				error.message = d.startsWith("40817")
					? "Счет принадлежит физическому лицу, уберите ИП из наименования получателя"
					: "Счет принадлежит юридическому лицу, уберите ИП из наименования получателя";
				return { isValid: false, error };
			}
			return { isValid: true, error };
		},

		bik: (value) => {
			return { isValid: true, error: {} };
		},

		/**
		 * Проверка ФИО (checkFIOpartNew в java)
		 * В соответствии с приказом ФНС:  https://www.consultant.ru/document/cons_doc_LAW_410788/763145d8bce1267a0501117c28ebd122104c1b8e/
		 * @param s - строка
		 * @return boolean
		 */
		fio: (value) => {
			value = String(value);
			const error = {};
			let isValid = false;

			// Предварительные проверки
			if (
				value.endsWith(" .")
				|| // заканчивается пробел+точка
				value.endsWith("(")
				|| // заканчивается открывающей скобкой
				value.includes("  ")
				|| // два пробела подряд
				value.includes("--")
				|| // два дефиса подряд
				value.includes("''")
				|| // два апострофа подряд
				value.includes(" .")
				|| // пробел перед точкой
				value.includes("- ")
				|| // пробел после дефиса
				value.includes(" -")
			) {
				return false;
			}

			// Основная проверка

			const russianLetters = "А-ЯЁа-яё";
			const romanNumerals = "IV";

			const pattern = "^[" + russianLetters + "]+"
				+ "("
				+ // Пробел + НЕ пробел
				"\\s[" + russianLetters + romanNumerals + "\\(\\)\\.]+" +
				"|" +
				// Дефис + НЕ дефис
				"\-[" + russianLetters + romanNumerals + "\\(\\)\\s\\.]+" +
				"|" +
				// Апостроф + НЕ апостроф
				"\'[" + russianLetters + romanNumerals + "\\(\\)\\s\\.]+" +
				"|" +
				// Запятая + пробел + буквы (запятая всегда с пробелом)
				"\\,\\s[" + russianLetters + romanNumerals + "\\(\\)\\.]+" +
				"|" +
				// Скобки и точки + любые разрешенные символы
				"[\\(\\)\\.][" + russianLetters + romanNumerals + "\\(\\)\\s\\.]+" +
				")*$";

			const regex = new RegExp(pattern);

			isValid = regex.test(value);

			if (!isValid) {
				error.message = "Некорректное ФИО";
			}

			return {
				isValid: isValid,
				error: error,
			};
		},
		/**
		 * Валидация почтового индекса
		 * @param {String} value
		 * @param {String} error
		 * @returns {undefined}
		 */
		postal_index: (value) => {
			value = String(value);
			const error = {};
			let isValid = false;


			if (!value.length) {
				error.code = 1;
				error.message = 'Почтовый индекс пуст';
			} else if (/[^0-9]/.test(value)) {
				error.code = 2;
				error.message = 'Почтовый индекс может состоять только из цифр';
			} else if (value.length < 4 || value.length > 9) { // индексы из других стран разной длины
				error.code = 3;
				error.message = 'Некорректный почтовый индекс';
				//error.message = 'Почтовый индекс может состоять только из 6 цифр';
			} else {
				isValid = true;
			}

			return {
				isValid: isValid,
				error: error,
			};
		},
		/**
		 * Валидация адреса
		 * не менее 3х слов
		 * на бэке auth.hasValidAddr
		 * @param {String} address
		 * @returns {undefined}
		 */
		address: (value) => {
			value = String(value);
			const error = {};
			let isValid = false;

			value = value.split(" ");
			if (value.length < 3) {
				error.message = 'Некорректный почтовый адрес';
			} else {
				isValid = true;
			}

			return {
				isValid: isValid,
				error: error,
			};
		},
		// есть форматирование, но валидацию оставил на всякий случай
		phone: (value) => {
			value = String(value);
			const error = {};
			let isValid = false;

			if (value.replace(/[^0-9.]/g, '').length < 11 || value.replace(/[^0-9.]/g, '').length > 11) {
				error.message = 'Некорректный номер телефона';
			} else {
				isValid = true;
			}

			return {
				isValid: isValid,
				error: error,
			};
		},
		email: (value) => {
			value = String(value);
			const error = {};
			let isValid = false;

			var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			isValid = re.test(value.toLowerCase());

			if (!isValid) {
				error.message = 'Некорректная почта';
			}

			return {
				isValid: isValid,
				error: error,
			};
		},
		full_name: (value) => {
			return Validator.notEmpty(value);
		},
		short_name: (value) => {
			return Validator.notEmpty(value);
		},
		bank_name: (value) => {
			return Validator.notEmpty(value);
		},
		recipient_name: (value) => {
			return Validator.notEmpty(value);
		},
		phone: (value) => {
			value = String(value);
			const error = {};
			let isValid = false;

			if (value.replace(/[^0-9.]/g, '').length < 11 || value.replace(/[^0-9.]/g, '').length > 11) {
				error.message = 'Некорректный номер телефона';
			} else {
				isValid = true;
			}

			return {
				isValid: isValid,
				error: error,
			};
		},

		kpp: (value) => {
			value = String(value);
			const error = {};
			let isValid = false;

			if (!value.length) {
				error.code = 1;
				error.message = 'КПП пуст';
			} else if (value.length !== 9) {
				error.code = 2;
				error.message = 'КПП может состоять только из 9 знаков (цифр или заглавных букв латинского алфавита от A до Z)';
			} else if (!/^[0-9]{4}[0-9A-Z]{2}[0-9]{3}$/.test(value)) {
				error.code = 3;
				error.message = 'Неправильный формат КПП';
			} else {
				isValid = true;
			}

			return {
				isValid: isValid,
				error: error,
			};
		},

		date: (value) => {
			value = String(value);
			const error = {};
			let isValid = false;

			if (value.length === 0) {
				return {
					isValid: isValid,
					error: { message: "Заполните дату!" },
				}
			}

			var separators = ['\\.'];
			var bits = value.split(new RegExp(separators.join('|'), 'g'));
			var d = new Date(bits[2], bits[1] - 1, bits[0]);
			var ret = bits.length == 3 && d.getFullYear() == bits[2] && d.getMonth() + 1 == bits[1];
			if (ret) {
				isValid = true;
			} else {
				error.message = "Неверный формат даты!";
			}

			return {
				isValid: isValid,
				error: error,
			};
		},

		floor: (value) => {
			const clean = value.replace(/\s/g, '');
			const num = parseInt(clean, 10);

			if (isNaN(num)) {
				return { isValid: false, error: { message: 'Введите корректное число' } };
			}
			// Ограничиваем разумным диапазоном
			if (num < -2 || num > 999) {
				return { isValid: false, error: { message: 'Допустимый диапазон: от -2 до 999' } };
			}
			return { isValid: true, error: {} };
		},

	};

	// ═══════════════════════════════════════════════════════════════════════════
	// операции с годами (сравнение, диапазон и т.д.)
	// ═══════════════════════════════════════════════════════════════════════════

	const YearUtils = {
		MIN: 1900,
		MAX: 2100,

		/**
		 * Проверка: является ли значение допустимым годом (полные 4 цифры + диапазон)
		 */
		isValid: (value) => {
			value = Formatter.digitsOnly(value);
			if (!value || value.length !== 4)
				return false;
			const year = Number(value);
			return year >= YearUtils.MIN && year <= YearUtils.MAX;
		},

		/**
		 * Возвращает доступный диапазон лет (для UI-компонентов: select, datepicker)
		 */
		getRange: () => ({ min: YearUtils.MIN, max: YearUtils.MAX }),

		/**
		 * Форматтер для ввода: не блокирует частичный ввод, но ограничивает финальное значение
		 */
		format: (value) => {
			value = Formatter.baseFormat(value);
			value = Formatter.digitsOnly(value);
			if (!value)
				return '';

			// Если пользователь ещё печатает (1-3 цифры) — не применяем clamp
			if (value.length < 4) {
				return value;
			}

			// Полное значение — ограничиваем диапазоном
			const year = Number(value);
			return String(Math.min(YearUtils.MAX, Math.max(YearUtils.MIN, year)));
		},

		/**
		 * Строгая нормализация: всегда возвращает год в диапазоне или пустую строку
		 * Используется при сохранении/отправке данных
		 */
		normalize: (value) => {
			value = Formatter.digitsOnly(value);
			if (!value)
				return '';
			const year = Number(value);
			if (year < YearUtils.MIN || year > YearUtils.MAX)
				return '';
			return String(year);
		}
	};


	// ═══════════════════════════════════════════════════════════════════════════
	// операции с датами (сравнение, диапазон и т.д.)
	// ═══════════════════════════════════════════════════════════════════════════
	const DateUtils = {
		/**
		 * Парсит строку "ДД.ММ.ГГГГ" в объект Date
		 * @param {string} dateStr - дата в формате DD.MM.YYYY
		 * @returns {Date|null}
		 */
		toDate: (dateStr) => {
			if (!dateStr)
				return null;

			const parts = String(dateStr).trim().split('.');
			if (parts.length !== 3)
				return null;

			const [day, month, year] = parts.map(Number);
			if (!day || !month || !year)
				return null;

			const date = new Date(year, month - 1, day);
			// Проверка на "перекос" даты (32.01 → 01.02)
			if (date.getDate() !== day || date.getMonth() !== month - 1) {
				return null;
			}
			return date;
		},

		/**
		 * Конвертирует дату в строку "ДД.ММ.ГГГГ"
		 * @param {Date|string|number} input - Date, timestamp или строка
		 * @returns {string}
		 */
		toDDMMYYYY: (input) => {
			const date = input instanceof Date ? input : DateUtils.toDate(input);
			if (!date || isNaN(date)) {
				return '';
			}

			const d = String(date.getDate()).padStart(2, '0');
			const m = String(date.getMonth() + 1).padStart(2, '0');
			const y = date.getFullYear();
			return `${d}.${m}.${y}`;
		},

		/**
		 * Конвертирует в формат для JSON/API: "YYYY-MM-DD"
		 * @param {string} dateStr - "ДД.ММ.ГГГГ"
		 * @returns {string|null}
		 */
		toISO: (dateStr) => {
			const date = DateUtils.toDate(dateStr);
			if (!date) {
				return null;
			}


			const d = String(date.getDate()).padStart(2, '0');
			const m = String(date.getMonth() + 1).padStart(2, '0');
			const y = date.getFullYear();
			return `${y}-${m}-${d}`;
		},

		/**
		 * Конвертирует в формат для JSON/API: "YYYY-MM-DD-T-HH-MM"
		 * @param {string} dateStr - "ДД.ММ.ГГГГ"
		 * @returns {string|null}
		 */
		toISODateTime: (dateStr, hours, minutes) => {
			const date = DateUtils.toISO(dateStr);
			if (!date) {
				return "";
			}

			return `${date}T${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
		},
		/**
		 * Конвертирует из ISO "YYYY-MM-DD" в "ДД.ММ.ГГГГ"
		 * @param {string} isoStr
		 * @returns {string}
		 */
		fromISO: (isoStr) => {
			if (!isoStr) {
				return '';
			}

			const [year, month, day] = isoStr.split('-');
			return `${day}.${month}.${year}`;
		},

		/**
		 * Конвертирует в timestamp (UTC midnight)
		 * @param {string} dateStr
		 * @returns {number|null}
		 */
		toTimestamp: (dateStr) => {
			const date = DateUtils.toDate(dateStr);
			if (!date) {
				return null;
			}

			return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
		},

		/**
		 * Сравнение двух дат в формате "ДД.ММ.ГГГГ"
		 * @returns {-1|0|1} -1: first < second, 0: equal, 1: first > second
		 */
		compare: (first, second) => {
			const d1 = DateUtils.toTimestamp(first);
			const d2 = DateUtils.toTimestamp(second);
			if (d1 === null || d2 === null) {
				return NaN;
			}

			return d1 === d2 ? 0 : (d1 > d2 ? 1 : -1);
		},

		/**
		 * Проверка: дата в диапазоне [min, max]
		 * @param {string} dateStr
		 * @param {string} [min]
		 * @param {string} [max]
		 * @returns {boolean}
		 */
		isInRange: (dateStr, min, max) => {
			const ts = DateUtils.toTimestamp(dateStr);
			if (ts === null) {
				return false;
			}

			if (min && ts < DateUtils.toTimestamp(min)) {
				return false;
			}

			if (max && ts > DateUtils.toTimestamp(max)) {
				return false;
			}

			return true;
		},

		/**
		 * Добавление дней к дате
		 * @param {string} dateStr
		 * @param {number} days
		 * @returns {string} новая дата в "ДД.ММ.ГГГГ"
		 */
		addDays: (dateStr, days) => {
			const date = DateUtils.toDate(dateStr);
			if (!date) {
				return '';
			}

			date.setDate(date.getDate() + days);
			return DateUtils.toDDMMYYYY(date);
		},

		/**
		 * Разница в днях между датами
		 * @returns {number|null}
		 */
		diffInDays: (first, second) => {
			const t1 = DateUtils.toTimestamp(first);
			const t2 = DateUtils.toTimestamp(second);
			if (t1 === null || t2 === null) {
				return null;
			}

			return Math.round((t1 - t2) / (1000 * 60 * 60 * 24));
		},

		/**
		 * Извлекает часы из строки в формате ISO "YYYY-MM-DDTHH:MM"
		 * @param {string} isoStr
		 * @returns {number|null}
		 */
		getHours: (isoStr) => {
			if (!isoStr || typeof isoStr !== 'string') {
				return null;
			}

			const match = isoStr.match(/T(\d{2}):/);
			return match ? parseInt(match[1], 10) : null;
		},

		/**
		 * Извлекает минуты из строки в формате ISO "YYYY-MM-DDTHH:MM"
		 * @param {string} isoStr
		 * @returns {number|null}
		 */
		getMinutes: (isoStr) => {
			if (!isoStr || typeof isoStr !== 'string') {
				return null;
			}

			const match = isoStr.match(/T\d{2}:(\d{2})/);
			return match ? parseInt(match[1], 10) : null;
		},

		/**
		 * Проверяет, что дата не раньше любой из указанных
		 * @param {string} date - проверяемая дата "ДД.ММ.ГГГГ"
		 * @param {...string} minDates - список минимальных дат для сравнения
		 * @returns {boolean} true, если date >= всех minDates
		 */
		isNotEarlierThanAll: (date, ...minDates) => {
			const ts = DateUtils.toTimestamp(date);
			if (ts === null) {
				return false;
			}

			for (const min of minDates) {
				const minTs = DateUtils.toTimestamp(min);
				if (minTs !== null && ts < minTs) {
					return false;
				}
			}
			return true;
		},

		/**
		 * Возвращает дату, не раньше указанной минимальной
		 * @param {string} date - проверяемая дата "ДД.ММ.ГГГГ"
		 * @param {string} minDate - минимальная допустимая дата
		 * @returns {string} исходная дата или minDate, если date < minDate
		 */
		ensureNotEarlierThan: (date, minDate) => {
			const ts = DateUtils.toTimestamp(date);
			const minTs = DateUtils.toTimestamp(minDate);

			// Если одна из дат невалидна — возвращаем исходную
			if (ts === null || minTs === null) {
				return date;
			}


			// Если date >= minDate — возвращаем как есть
			if (ts >= minTs) {
				return date;
			}


			// Иначе возвращаем minDate
			return minDate;
		},
		/**
		 * Возвращает дату, не раньше любой из указанных минимальных дат.
		 * Игнорирует пустые или невалидные даты в массиве.
		 *
		 * @param {string} date - проверяемая дата "ДД.ММ.ГГГГ"
		 * @param {string[]} minDates - массив минимальных допустимых дат ["ДД.ММ.ГГГГ", ...]
		 * @returns {string} исходная дата или максимальная из валидных minDates, если date < неё
		 */
		ensureNotEarlierThanAll: (date, minDates = []) => {
			const ts = DateUtils.toTimestamp(date);

			// Если проверяемая дата невалидна, возвращаем её как есть
			if (ts === null) {
				return date;
			}

			let maxMinTs = null;
			let maxMinDateStr = null;

			// Проходим по массиву и ищем самую позднюю (максимальную) валидную дату
			for (const minDate of minDates) {
				const minTs = DateUtils.toTimestamp(minDate);
				if (minTs !== null) {
					if (maxMinTs === null || minTs > maxMinTs) {
						maxMinTs = minTs;
						maxMinDateStr = minDate; // запоминаем исходную строку
					}
				}
			}

			// Если в массиве не было ни одной валидной даты, возвращаем исходную
			if (maxMinTs === null) {
				return date;
			}

			// Если проверяемая дата >= самой поздней минимальной даты — всё корректно
			if (ts >= maxMinTs) {
				return date;
			}

			// Иначе сдвигаем дату до этой максимальной минимальной даты
			return maxMinDateStr;
		},

		/**
		 * Проверяет, что дата не позже сегодняшней (дата <= сегодня)
		 * @param {string} dateStr - проверяемая дата в формате "ДД.ММ.ГГГГ"
		 * @returns {boolean} true, если дата валидна и не позже сегодняшнего дня
		 */
		isNotLaterThanToday: (dateStr) => {
			const ts = DateUtils.toTimestamp(dateStr);
			if (ts === null) {
				return false;
			}

			const now = new Date();
			const todayTs = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());

			return ts <= todayTs;
		},

		/**
		 * Возвращает сегодняшнюю дату в формате "ДД.ММ.ГГГГ"
		 * @returns {string}
		 */
		getToday: () => {
			const now = new Date();
			const d = String(now.getDate()).padStart(2, '0');
			const m = String(now.getMonth() + 1).padStart(2, '0');
			const y = now.getFullYear();
			return `${d}.${m}.${y}`;
		},

	};

	// ═══════════════════════════════════════════════════════════════════════════
	// СХЕМЫ ПОЛЕЙ
	// ═══════════════════════════════════════════════════════════════════════════
	const FIELD_SCHEMAS = {
		// === данные огранизационной формы  ===
		inn: {
			label: 'ИНН',
			placeholder: 'Введите ИНН',
			validate: Validator.inn,
			format: Formatter.digitsOnly,
			autocomplete: false,
		},
		recipient_inn: {
			label: `ИНН получателя <span style="color: red">(не банка!)`,
			placeholder: 'Введите ИНН получателя',
			validate: Validator.inn,
			format: Formatter.digitsOnly,
			autocomplete: false,
		},
		ogrn: {
			type: 'text',
			label: 'ОГРН',
			placeholder: 'Введите ОГРН',
			validate: Validator.ogrn,
			format: Formatter.digitsOnly,
			maxlength: 13,
			autocomplete: false,
		},
		ogrnip: {
			label: 'ОГРНИП',
			placeholder: 'Введите ОГРНИП',
			validate: Validator.ogrn,
			format: Formatter.digitsOnly,
			maxlength: 15,
			autocomplete: false,
		},
		snils: {
			label: 'СНИЛС',
			placeholder: 'Введите СНИЛС',
			validate: Validator.snils,
			//format: Formatter.digitsOnly,
			mask: {
				mask: '***-***-*** **',
				tokens: {
					'*': { pattern: /[0-9]/ },
				},
				eager: true
			},
			maxlength: 14, // по факту 11, но с маской  нужно место
			autocomplete: false,
		},

		full_name: {// (только ЮР)
			label: 'Полное наименование',
			placeholder: 'Общество с ограниченной ответственностью "Ромашка"',
			validate: Validator.full_name,
			format: Formatter.orgName,
			maxlength: 500,
			autocomplete: false,
		},
		short_name: {// (только ЮР)
			label: 'Краткое наименование',
			placeholder: 'ООО "Ромашка"',
			validate: Validator.short_name,
			format: Formatter.orgName,
			maxlength: 255,
			autocomplete: false,
			required: false, // 4915 - ни одна организационно-правовая форма не обязана иметь сокращённое наименование.
		},

		address: {// адрес Юрлиц
			label: 'Адрес',
			placeholder: 'г. Москва, ул. Гагарина',
			validate: Validator.address,
			format: Formatter.address,
			maxlength: 255,
		},

		recipient_name: {
			label: 'Наименование получателя',
			placeholder: 'ООО "Ромашка"',
			validate: Validator.recipient_name,
			format: Formatter.orgName,
			maxlength: 255,
			autocomplete: false,
		},

		postal_address: {// почтовый адрес
			label: 'Почтовый адрес',
			placeholder: 'г. Москва, ул. Гагарина',
			validate: Validator.address,
			format: Formatter.address,
			maxlength: 255,
		},

		// === Реквизиты  ===
		kpp: {
			type: 'tel',
			label: 'КПП',
			placeholder: 'Укажите КПП',
			validate: Validator.kpp,
			format: Formatter.digitsOnly,
			maxlength: 9,
		},

		bank_name: {
			label: 'Банк',
			placeholder: 'Краткое наименование Банка или БИК',
			validate: Validator.bank_name,
			format: Formatter.orgName,
			maxlength: 1000,
		},

		bik: {
			label: 'БИК',
			placeholder: 'Выберите банк',

			validate: Validator.bik,
			format: Formatter.digitsOnly,
			maxlength: 9,
		},
		rs: {
			label: 'Счёт',
			placeholder: 'Заполните счёт',
			validate: (value, context) => Validator.rs(value, context?.bik),
			format: Formatter.digitsOnly,
			maxlength: 20,
			dependencies: ['bik']
		},
		ks: {
			label: 'К/С',
			placeholder: 'Выберите банк',
			//validate: (value, context) => Validator.rs(value, context?.bik),
			format: Formatter.digitsOnly,
			maxlength: 20,
			dependencies: ['bik']
		},

		// === контакты  ===
		email: {
			label: "Адрес электронной почты",
			placeholder: 'example@mail.ru',
			validate: Validator.email,
			maxlength: 320,
			valueMask(value) {
				// Маскировка значения
			},
		},
		phone: {
			type: 'text',
			label: 'Номер контактного телефона',
			placeholder: '+7 (___) ___-__-__',
			validate: Validator.phone,

			valueMask(value) {
				// Маскировка значения
			},

			format: Formatter.phone,
			// Пока есть маска, форматирование не работает
			mask: {
				mask: "+7 (***) ***-**-**",
				tokens: { "*": { pattern: /[0-9]/ } },
				eager: true
			},
		},

		imya: {
			label: 'Имя',
			//placeholder: 'Иван',
			validate: Validator.fio,
			format: Formatter.fio,
			maxlength: 50,
			autocomplete: false,
		},

		famil: {
			label: 'Фамилия',
			//placeholder: 'Иванов',
			validate: Validator.fio,
			format: Formatter.fio,
			maxlength: 50,
			autocomplete: false,
		},
		otch: {
			label: 'Отчество',
			//placeholder: 'Иванович',
			validate: Validator.fio,
			format: Formatter.fio,
			maxlength: 50,
			autocomplete: false,
		},

		// ===  типы полей  ===
		date: {
			label: "Дата",
			placeholder: 'Укажите дату',
			validate: Validator.date,
			format: Formatter.date,
			autocomplete: false,
			//			mask: {
			//				mask: "**.**.****",
			//				tokens: {"*": {pattern: /[0-9]/}},
			//				eager: true
			//			}
		},
		mm: {
			label: "Минуты",
			placeholder: "00",
			default: "00",
			format: Formatter.minutes,
			maxlength: 2,
			autocomplete: false,
		},
		hh: {
			label: "Часы",
			placeholder: "00",
			default: "00",
			format: Formatter.hours,
			maxlength: 2,
			autocomplete: false,
		},
		year: {
			label: "Год",
			placeholder: "1900",
			format: YearUtils.format,
			validate: Validator.year,
			maxlength: 4,
			autocomplete: false,
		},

		video: {
			label: "Видео",
			placeholder: "Ссылка на видео Rutube",
			maxlength: 1000,
			autocomplete: false,
		},

		textarea: {
			rows: 3,
			maxlength: 3000,
		},
		big_textarea: {
			rows: 10,
			maxlength: 10000,
		},

		// === специфичные поля  ===
		efrsb_id: {
			label: 'Идентификационный номер торгов на ЕФРСБ',
			placeholder: 'Введите номер',
			maxlength: 8,
			format: Formatter.digitsOnly,
			validate: Validator.efrsb_id,
			autocomplete: false,
		},

		vin: {
			label: "Идентификационный номер (VIN)",
			placeholder: "1ZVHT84N495104650",
			format: Formatter.vin,
			maxlength: 17,
		},

		floor: {
			label: 'Этаж',
			placeholder: '00',
			maxlength: 3,
			mask: {
				mask: 'number',
				number: {
					locale: 'ru-RU',
					fraction: 0, // только целые числа
					unsigned: false   // разрешаем знак минус (по умолчанию false, но явно указываем для ясности)
				},
				eager: true
			},
			validate: Validator.floor,
			autocomplete: false,
			onSendToBackend(value) {
				return BackendFormatter.number(value);
			}
		},

		// ==== МАСКИ ЦИФР
		// Для целых чисел без группировки
		xxx: {
			placeholder: "00",
			maxlength: 3,
			format(value) {
				value = Formatter.baseFormat(value);
				value = Formatter.digitsOnly(value);
				if (!value)
					return "";

				const num = Number(value);
				if (isNaN(num)) {
					return "1";
				}

				if (num < 1) {
					return "1";
				}
				if (num > 999) {
					return "999";
				}

				return value;
			},
			onSendToBackend(value) {
				return BackendFormatter.number(value);
			}
		},
		xxxx: {
			placeholder: "00",
			maxlength: 4,
			format(value) {
				value = Formatter.baseFormat(value);
				value = Formatter.digitsOnly(value);
				if (!value)
					return "";

				const num = Number(value);
				if (isNaN(num)) {
					return "1";
				}

				if (num < 1) {
					return "1";
				}
				if (num > 9999) {
					return "9999";
				}

				return value;
			},
			onSendToBackend(value) {
				return BackendFormatter.number(value);
			}
		},

		// Для цен и больших чисел используем группировку по маске
		xx_00: {
			placeholder: "00",
			//maxlength: 5,
			mask: {
				mask: 'number',
				number: { locale: 'ru-RU', fraction: 2, unsigned: true },
				eager: true,
				// изменение до применения маски
				preProcess: (value) => {
					const clean = value.replace(/[^\d.,]/g, '');
					const parts = clean.split(/[.,]/);
					let int = parts[0].slice(0, 2);
					if (parts.length > 1) {
						return int + '.' + parts[1].slice(0, 2);
					}
					return int;
				}
			},
			onSendToBackend(value) {
				return BackendFormatter.number(value);
			}

		},

		xxxx_00: {
			placeholder: "0000,00",
			//maxlength: 7,
			mask: {
				mask: 'number',
				number: { locale: 'ru-RU', fraction: 2, unsigned: true },
				eager: true,
				// изменение до применения маски
				preProcess: (value) => {
					const clean = value.replace(/[^\d.,]/g, '');
					const parts = clean.split(/[.,]/);
					let int = parts[0].slice(0, 4);
					if (parts.length > 1) {
						return int + '.' + parts[1].slice(0, 2);
					}
					return int;
				}
			},
			onSendToBackend(value) {
				return BackendFormatter.number(value);
			}

		},

		x_xxx_xxx: {
			placeholder: "0 000 000",
			//maxlength: 9,
			mask: {
				mask: 'number',
				number: { locale: 'ru-RU', fraction: 0, unsigned: true },
				eager: true,
				// изменение до применения маски
				preProcess: (value) => {
					return value.replace(/[^\d]/g, '').slice(0, 7);
				}
			},
			onSendToBackend(value) {
				return BackendFormatter.number(value);
			}
		},

		xxx_xxx_xxx__00: {
			placeholder: "0 000 000",
			//maxlength: 15,
			mask: {
				mask: 'number',
				number: { locale: 'ru-RU', fraction: 2, unsigned: true },
				eager: true,
				// изменение до применения маски
				preProcess: (value) => {
					const clean = value.replace(/[^\d.,]/g, '');
					const parts = clean.split(/[.,]/);
					let int = parts[0].slice(0, 9);
					if (parts.length > 1) {
						return int + '.' + parts[1].slice(0, 2);
					}
					return int;
				}
			},
			onSendToBackend(value) {
				return BackendFormatter.number(value);
			}
		},

		xx_xxx_xxx_xxx_xxx_00: {
			placeholder: "0 000 000",
			//maxlength: 21,
			mask: {
				mask: 'number',
				number: { locale: 'ru-RU', fraction: 2, unsigned: true },
				eager: true,
				// изменение до применения маски
				preProcess: (value) => {
					const clean = value.replace(/[^\d.,]/g, '');
					const parts = clean.split(/[.,]/);
					let int = parts[0].slice(0, 14);
					if (parts.length > 1) {
						return int + '.' + parts[1].slice(0, 2);
					}
					return int;
				}
			},
			onSendToBackend(value) {
				return BackendFormatter.number(value);
			}
		}
	};

	// ═══════════════════════════════════════════════════════════════════════════
	// ОБРАБОТЧИКИ СОБЫТИЙ
	// ═══════════════════════════════════════════════════════════════════════════

	/**
	 * Обработчики для полей формы
	 * @type type
	 */
	const FieldHandlers = {
		/**
		 * форматирование инпута + отслеживание курсора
		 * @param {type} event - событие
		 * @param {type} fieldName - имя поле. ищем форматтер для него по Field_Schemas
		 * @returns значение инпута
		 */
		formatEvent(event, fieldName, store) {
			const input = event.target;

			let formatter = null;

			if (store) {
				formatter = store?.getFieldRules(fieldName)?.format;

				if (!formatter) {
					formatter = FIELD_SCHEMAS[fieldName]?.format;
				}

			} else {
				formatter = FIELD_SCHEMAS[fieldName]?.format;
			}

			if (!formatter || store?.getFieldRules(fieldName)?.mask) {
				return input.value;
			}

			const oldValue = input.value;
			const cursorPos = input.selectionStart;
			// Считаем "полезные" символы до курсора (буквы/цифры)
			const charsBeforeCursor = oldValue.slice(0, cursorPos).replace(/[^а-яА-ЯёЁa-zA-Z0-9\s]/g, '').length;
			// форматируем значение
			const newValue = formatter(oldValue);
			input.value = newValue;
			// Находим позицию где столько же полезных символов
			let count = 0;
			let newCursor = 0;
			for (let i = 0; i < newValue.length && count < charsBeforeCursor; i++) {
				if (/[а-яА-ЯёЁa-zA-Z0-9\s]/.test(newValue[i])) {
					count++;
				}
				newCursor = i + 1;
			}

			// Восстанавливаем курсор
			requestAnimationFrame(() => {
				input.setSelectionRange(newCursor, newCursor);
			});
			return input.value;
		},

		/**
		 * Убираем пробел при потере фокуса
		 * @param {type} event
		 * @param {type} fieldName
		 * @param {type} store
		 * @returns {input.value|.event.target.value|String}
		 */
		blurFormat(e) {
			const input = e.target;

			input.value = String(input.value).trim();
			return input.value;
		},

		/**
		 * Очищаем дату при потере фокуса
		 * @param {type} e
		 * @returns {input.value|.e.target.value|String|.event.target.value}
		 */
		clearDataOnBlur(e) {
			const input = e.target || e;
			const val = input.value || '';

			let formattedVal = this.blurFormat(e);

			// Если дата неполная (меньше 10 символов или есть __) — очищаем
			if (val.length < 10 || /__/.test(val)) {
				input.value = '';
				return '';
			}

			// Если есть символы кроме цифр и точек — очищаем
			if (/[^0-9.]/.test(val)) {
				input.value = '';
				return '';
			}

			e.target.value = formattedVal;
			return formattedVal
		},
	}


	// ═══════════════════════════════════════════════════════════════════════════
	// PUBLIC API
	// ═══════════════════════════════════════════════════════════════════════════

	const publicAPI = {
		// Форматтеры
		format: (fieldName, value, ctx) => {
			const formatter = FIELD_SCHEMAS[fieldName]?.format || Formatter[fieldName];
			if (formatter) {
				return formatter(value, ctx);
			}
			return console.error("нет форматтера!");
		},
		backendFormat: (fieldName, value, ctx) => {
			const formatter = BackendFormatter[fieldName];
			if (formatter) {
				return formatter(value, ctx);
			}
			return console.error("нет форматтера!");
		},

		// Операции с датами
		date: DateUtils,

		getValidator: (name) => Validator[name] || null,

		// Валидаторы
		validate: (fieldName, value, ctx) => {
			const validator = Validator[fieldName] || FIELD_SCHEMAS[fieldName]?.validate;
			if (validator) {
				return validator(value, ctx);
			}
			return { isValid: true, error: {} };
		},

		// Схемы полей
		getAllSchemas: () => FIELD_SCHEMAS,
		getSchema: (fieldName) => FIELD_SCHEMAS[fieldName] || {},

		// Маски
		getMask: (fieldName) => FIELD_SCHEMAS[fieldName]?.mask,

		// Обработчики событий
		handlers: FieldHandlers,
	};

	return publicAPI;
})();
